<template>
    <div>
        <div class="text-right" style="margin-bottom: 24px">
            <a-button type="primary" icon="plus" @click="showModal()" v-if="!isAttendant"> Tambah </a-button>
        </div>

        <a-card type="inner" size="small" title="Dokumentasi">
            <a-tabs>
                <a-tab-pane key="1" tab="Foto">
                    <documentation :type="type" :title="title" :cmc="cmc" document="image" />
                </a-tab-pane>
                <a-tab-pane key="2" tab="File">
                    <documentation :type="type" :title="title" :cmc="cmc" document="file" />
                </a-tab-pane>
                <a-tab-pane key="3" tab="Video">
                    <documentation :type="type" :title="title" :cmc="cmc" document="video" />
                </a-tab-pane>
            </a-tabs>
        </a-card>

        <a-modal
            :visible="visible"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <a-card type="inner" size="small">
                <a-form :form="form" :layout="formLayout" @submit="handleSubmit" >
                    <a-divider dashed orientation="left">Upload</a-divider>

                    <a-form-item label="Tipe File">
                        <a-radio-group v-decorator="['type', { initialValue: 'image'}]">
                            <a-radio value="image">
                            Foto
                            </a-radio>
                            <a-radio value="file">
                            File
                            </a-radio>
                            <a-radio value="video">
                            Video
                            </a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item>
                        <a-upload
                            :file-list="fileList"
                            :remove="handleRemove"
                            :before-upload="beforeUpload"
                            @change="handleChange"
                        >
                            <a-button>
                                <a-icon type="upload" /> Select File
                            </a-button>
                        </a-upload>
                    </a-form-item>
                    <a-form-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-modal>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            cmc: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                visible: false,
                processing: false,
                fileList: [],
                formLayout: 'horizontal',
                form: this.$form.createForm(this),
            }
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            isAttendant() {
                return this.$laravel.membership.is_attendant
            }
        },
        methods: {
            showModal() {
                this.visible = true;
            },
            handleClose(isRefresh) {
                this.visible = false;

                this.fileList = []

                if (isRefresh == true) {
                    this.getItems();
                }
            },
            handleSubmit(e) {
                e.preventDefault(e);

                this.form.validateFields((err, formData) => {
                    if (!err) {
                        this.processing = true;

                        let promise;

                        var data = new FormData();

                        for (var k in formData) {
                            if (formData.hasOwnProperty(k)) {
                                data.append(k, formData[k]);
                            }
                        }

                        data.append("attachment", this.fileList[0]);

                        promise = this.$http.post(
                            this.routeUri("api.cmc-files.files.create", {
                                cmc: this.cmc
                            }),
                            data
                        );

                        promise
                            .then(response =>
                                this.handleSuccessResponse(response.data)
                            )
                            .catch(error =>
                                this.handleResponseError(error.response.data)
                            )
                            .finally(() => (this.processing = false));
                    }
                });
            },
            handleSuccessResponse(data) {
                var successMessage = "Data berhasil diproses!";

                if (typeof data.successMessage != "undefined") {
                    successMessage = data.successMessage;
                }

                this.$notification.success({
                    message: "Sukses!",
                    description: successMessage
                });
                setTimeout(() => window.location.reload(), 2000);
            },
            handleResponseError(data) {
                if (data.hasOwnProperty("errors")) {
                    for (let key in data.errors) {
                        this.$notification.error({
                            message: "Gagal proses " + key,
                            description: Object.values(data.errors[key])
                        });
                    }
                } else {
                    this.$notification.error({
                        message: "Gagal proses",
                        description: "Data tidak dapat diproses."
                    });
                }
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();

                newFileList.splice(index, 1);

                this.fileList = newFileList;
            },
            beforeUpload(file) {
                this.fileList = [...this.fileList, file];

                return false;
            },
            handleChange(info) {
                let fileList = [...info.fileList];

                if (fileList.length > 1) {
                    fileList = fileList.slice(-1);

                    fileList = fileList.map(file => {
                        if (file.response) {
                            file.url = file.response.url;
                        }
                        return file;
                    });
                    this.fileList = fileList;
                }
            },
        }
    }
</script>
